export default __webpack_public_path__ + "static/media/A_01_01_ping_v01.314baa84.mp3";